import React, { useState, useEvent, useEffect } from 'react'
import { useLocation,Navigate } from 'react-router-dom';
import ReactDOM from 'react-dom';
import Menulist from '../components/Menulist';
import axios from 'axios';
import Resizer from "react-image-file-resizer";
import HeaderCollapse from '../components/HeaderCollapse';
import HeaderCollapseMobile from '../components/HeaderCollapseMobile';
import {removeProfileUserImage,updateuserprofile} from '../config/Variables';
import {baseurl} from '../config/Settings';




function EditProfile() {
  const location = useLocation();
  async function openFile(){
    document.getElementById("get_file").onClick=document.getElementById("img-input").click();
  }
 
  //let user = JSON.parse(localStorage.getItem('user-info'));
  //if(localStorage.getItem('user-info')){
  // let user = JSON.parse(localStorage.getItem('user-info'))
  //  }
  //var element = document.getElementById("header-react");
  //element.classList.remove("hide");

  var element = document.getElementById("header-react");
if(element){
  element.classList.remove("hide");
}
document.body.classList.remove('path-journey');
  let user = JSON.parse(localStorage.getItem('user-info'));
  var x = '';
  var y = '';
  var image_changed= 0;
  
  let displayname;
  let lastnamevar;
  let gendervar;
  let occupationvar;
  let birthdayvar;
  let profile_url_var="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/default-author.png?1";
  let image_var;
  if (localStorage.getItem('user-info')) {
    //let user = JSON.parse(localStorage.getItem('user-info'));
    if(user.user.display_name){
     displayname=user.user.display_name;
    }else{
      displayname="مجهول";
    }
      lastnamevar=user.user.last_name;
      gendervar= user.user.gender;
      occupationvar =user.user.occupation;
      birthdayvar=user.user.birthday;
      profile_url_var=user.user.profile_url;
      image_var=user.user.image;
      
  }else{
    displayname="";
    lastnamevar="";
    gendervar= "";
    occupationvar="";
    birthdayvar="";
    profile_url_var="";
    image_var="";
  }
  
  if (birthdayvar && birthdayvar != '') {
    const answer_array = birthdayvar.split('-');
    x = answer_array[0];
    y = answer_array[1];
  }
  const [birth_month, setMonthBirth] = useState(y);
  const [birth_year, setYearBirth] = useState(x);

  //const [email, setEmail] = useState();
   const [selectedFile, setSelectedFile] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [password, setPassword] = useState();
  const [device_name, setDevice] = useState();
  const [provider_id, setProviderid] = useState();
  const [provider, setProvider] = useState();
  const [display_name, setFirstname] = useState(displayname);
  const [user_name, setUserName] = useState(displayname);
  const [last_name, setLastname] = useState(lastnamevar);
  const [mobile, setMobile] = useState();
  const [image, setImage] = useState(image_var);
  const [profile_url, setProfileurl] = useState(profile_url_var);
  const [gender, setGender] = useState(gendervar);
  const [occupation, setOccupation] = useState(occupationvar);
  

  const [birthdayt, setBirthday] = useState();
  const [message, setMessage] = useState();
  // const answer_array = user.user.birdthday;
  if (birthdayvar && birthdayvar != '') {
    const answer_array = birthdayvar.split('-');
    if (answer_array[0]) {
      var monthyear = answer_array[0];
    }
    if (answer_array[1]) {
      var monthbirth = answer_array[1];
    }


  }


  useEffect(() =>{ 
    console.log(selectedFile); 

    if(selectedFile!=false){
          if(isValidFileUploaded(selectedFile)){
          image_changed= 1;
          //setSelectedFile( resizeFile(selectedFile));
          //console.log(selectedFile);
          const objectUrl = URL.createObjectURL(selectedFile)
          document.getElementById("u_profile_img").setAttribute('src', objectUrl);

        }else{
          //file is invalid
          image_changed=0;
          document.getElementById("img-input").value = "";
          setMessage('صيغة الملف غير مقبولة.. يمكنك اختيار صورة فقط');
        }
      }
   
  }, [selectedFile]);


  const isValidFileUploaded=(file)=>{
    const validExtensions = ['png','jpeg','jpg', 'gif'];
    const fileExtension = file.type.split('/')[1];
    return validExtensions.includes(fileExtension);
  }

  const resizeFile = (file) => new Promise(resolve => {
      Resizer.imageFileResizer(file, 300, 300, 'JPEG', 100, 0,
      uri => {
        resolve(uri);
      }, 'file' ,100, 100);
  });

  const handleInputChange = (event) =>{
           //console.log(event);
          setSelectedFile( event.target.files[0]);
          console.log(selectedFile);
          image_changed= 1;

      
          if(selectedFile!=false){
            if(isValidFileUploaded(selectedFile)){
            image_changed= 1;
            //setSelectedFile( resizeFile(selectedFile));
            console.log(selectedFile);
            
            const objectUrl = URL.createObjectURL(selectedFile)
            document.getElementById("u_profile_img").setAttribute('src', objectUrl);
  
          }else{
            //file is invalid
            image_changed=0;
            document.getElementById("img-input").value = "";
            setMessage('صيغة الملف غير مقبولة.. يمكنك اختيار صورة فقط');
          }
        }
    
       //console.log(image_changed);
    }

  async function resetMsg(){
      setMessage('');
  }


  async function removeImage() {
    if (localStorage.getItem('user-info')) {
          let user = JSON.parse(localStorage.getItem('user-info'));
          let result =  await fetch(removeProfileUserImage, {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Accept": 'application/json',
              "Authorization": "Bearer " + user.token.access_token,
            }
            
          }).catch(console.log);
          result = await result.json();
    
          if (result.message.code == '200') {  

            let user = JSON.parse(localStorage.getItem('user-info'));
           


           

            user.user.image = '';
            user.user.profile_url = '';
            setImage(user.user.image);
            setProfileurl(user.user.profile_url);
            
            localStorage.setItem('user-info', JSON.stringify(user));
            console.log(user);
           //temp  document.getElementById("user-profile-img-el").setAttribute('src', baseurl+'themes/custom/aawsatv3/assets-react/img/icon/avatardefault.png');
            setMessage(result.webmsg.message);
  
          }
        }
  }

  
  async function login() {
    let user = JSON.parse(localStorage.getItem('user-info'));
    console.log('this is login');
    console.log(display_name);
     console.log(selectedFile);
    const email = user.user.email;


    if (gender) {
      console.log("iam herer gender")
      user.user.gender = gender;
    } else {
      setGender(user.user.gender);
    }

    if (occupation) {
      user.user.occupation = occupation;
    } else {
      setOccupation(user.user.occupation);
    }

    if (display_name) {
      user.user.display_name = display_name;
      user.user.name = display_name;
    } else {
      if(user.user.display_name){
        setFirstname(user.user.display_name);
      }else{
        setFirstname("مجهول");
      }
     
    }
    if (last_name) {
      user.user.last_name = last_name;

    } else {
      setLastname(user.user.last_name);
    }



    if (birth_month && birth_year) {
      var birthday = birth_year + '-' + birth_month + '-01';
      //setBirthday('01-'+birth_month +'-'+birth_year)
      user.user.birthday = birthday;
    } else if (monthyear && monthbirth) {
      //user.user.birthday=birthday;
      var birthday = monthyear + '-' + monthbirth + '-01';
      //setBirthday('01-'+birth_month +'-'+birth_year)
      user.user.birthday = birthday;
    } else {
      var birthday = user.user.birthday;
    }

 if (localStorage.getItem('user-info')) {
    let data = new FormData();
    console.log("tttta lovelty");
    console.log(display_name);
      if(display_name==""){
        display_name="مجهول";
      }
      data.append('email', email);
      if(gender){
        data.append('gender', gender);
      }
      if(birthday){
        data.append('birthday', birthday);
      }
      if(occupation){
        data.append('occupation', occupation);
      }
      if(last_name){
        data.append('last_name', last_name);
      }
      if(display_name){
        data.append('display_name', display_name);
      }
  
      if(selectedFile!==false){
        console.log('this image passed');
        data.append('image', selectedFile);
        console.log(selectedFile);
      }

      data.append('test', 'test');

        let config = {
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + user.token.access_token,
              }
            };
        
        let url = updateuserprofile;

          axios.post(url, data, config)
          .then(res => { // then print response status
            //console.warn(res.data);
            if(res.status==401){

             // document.getElementById("expired_btn").click();
              localStorage.clear();
              window.location.href = '/journey#/login/'+user.user.email+'?destination='+window.location.href; 
            }
            if (res.data.message.code == '200') {
              user.user.image = JSON.stringify(res.data.user.image);
              user.user.profile_url = res.data.user.profile_url;
            //setMessage("لقد تم حفظ التغييرات")
            setImage(user.user.image);
            setProfileurl(user.user.profile_url);
            if(user.user.profile_url)
            {
              document.getElementById("user-profile-img-el").setAttribute('src', user.user.profile_url);
             // document.getElementById("user-profile-img-el-mob").setAttribute('src', user.user.profile_url);
            }
           //temp document.getElementById("user-profile-img-el").setAttribute('src', user.user.profile_url);
            
            //console.log(JSON.stringify(res.user));
            image_changed=0;
            setIsEdited(false);
          document.getElementById("img-input").value = "";
            setMessage("لقد تم حفظ التغييرات")

            localStorage.setItem('user-info', JSON.stringify(user));
            setUserName(display_name.substring(0, 15));
            setFirstname(display_name);
            console.log(res.data.user);
          

            }else{
              setMessage(res.data.message);
             document.getElementById("img-input").value = "";
              setImage(user.user.image);
              setProfileurl(user.user.profile_url);
              image_changed=0;
            }
            var menu_collapse = document.getElementById("menu_collapse");
            if(menu_collapse){
            ReactDOM.render(
            <React.StrictMode>
            <HeaderCollapse />
            </React.StrictMode>,
            document.getElementById('menu_collapse')
            );
            }
            var menu_collapse = document.getElementById("menu_collapse_mobile");
            if(menu_collapse){
            ReactDOM.render(
            <React.StrictMode>
            <HeaderCollapseMobile />
            </React.StrictMode>,
            document.getElementById('menu_collapse_mobile')
            );
          }
          }) 
          
          //add catch
          // update profile img on current page
          // add messages error and success
      }else {
        setImage(user.user.image);
        setProfileurl(user.user.profile_url);
      }

    
    }
    //history('/add');
  if (!localStorage.getItem('user-info')) {

    return <Navigate to="/" />

  } else {
    return (

      <div className="grid-container">

        <div className="grid-x grid-margin-x my-page">
          <div className="cell large-3">
            <Menulist samircallback={location.pathname} />
          </div>
          <div className="cell auto">
            <div className="mypage-area">

              <div className="tabs-content" data-tabs-content="profile-tabs"></div>
              <div className="tabs-panel is-active" id="editprofile" >
                <div className="profile-content">
                  <h3 className="message alert text-center"> {message}</h3>
                  <div className="grid-x grid-margin-x align-middle">
                    <div className="cell shrink">
                      <div className="profile-avatar">
                       
                      <button class="profile-avatar-edit"  onClick={() => openFile()}><i class="icomoon-icon icon-edit"></i></button>
                        <div className="profile-avatar-img round user-img-wrap" id="get_file" onClick={() => openFile()}>
                                            <div className="user-img">
                                                <img src={user.user.profile_url?user.user.profile_url :"https://aawsat.com/themes/custom/aawsatv3/assets-react/img/default-author.png?1"} alt="user" id="u_profile_img"/>
                                            </div>
                                            <div className="user-img-icon">
                                                <i className="icomoon-icon icon-camera"></i>
                                                <input  hidden type="file" type="file" className="no-ico" accept=".jpg,.png,.jpeg,.gif,.svg" id="img-input" name="upload_file" onFocus={resetMsg} onChange={(e) => {handleInputChange(e);setIsEdited(true)}}/>
                                            </div>
                                        </div>
                      </div>
                    </div>
                    <div className="cell auto medium-9">
                      <div className="profile-details">
                        <h3>اسم المستخدم</h3>
                        <span>{user_name}</span>
                      </div>

                    </div>
                  </div>
                </div>

                <div className="form-area max-width">
               
                  <div className="grid-x grid-margin-x align-middle">
                    <div className="cell medium-5">
                      <label>الاسم</label>
                      <div className="input-field">
                        <span className="ico-label"><i className="icomoon-icon icon-user-circle-o"></i></span>
                        <input type="text" required name="first_name" placeholder="الاسم الأول" defaultValue={user.user.display_name ? user.user.display_name :""} onFocus={resetMsg} onChange={(e) => {setFirstname(e.target.value);setIsEdited(true)}} />
                      </div>
                    </div>
                    <div className="cell medium-5">
                      <label>اسم العائلة</label>
                      <div className="input-field">
                        <span className="ico-label"><i className="icomoon-icon icon-user-circle-o"></i></span>
                        <input type="text" required name="last_name" placeholder="اسم العائلة" defaultValue={user.user.last_name!="null" ?user.user.last_name:''} onFocus={resetMsg} onChange={(e) => {setLastname(e.target.value); setIsEdited(true)}} />
                      </div>
                    </div>



                    <div className="cell medium-2 cstm-inpt">
                    {user.user.provider_id ==null &&
                      <a href="#/change_password" className="update-password classic">تغيير كلمة المرور </a>
  }
                    </div>

                    <div className="cell medium-5">

                      <label>تاريخ الميلاد </label>
                      <div className="input-field">
                      <select id="month" defaultValue={monthbirth} name="month" onFocus={resetMsg} onChange={(e) => {setMonthBirth(e.target.value);setIsEdited(true)}}>
                          <option>الشهر</option>
                          <option value="01">يناير</option>
                          <option value="02">فبراير</option>
                          <option value="03">مارس</option>
                          <option value="04">أبريل</option>
                          <option value="05">مايو</option>
                          <option value="06">يونيو</option>
                          <option value="07">يوليو</option>
                          <option value="08">أغسطس</option>
                          <option value="09">سبتمبر</option>
                          <option value="10">أكتوبر</option>
                          <option value="11">نوفمبر</option>
                          <option value="12">ديسمبر</option>
                        </select>
                      <select id="year" defaultValue={monthyear} name="year" onFocus={resetMsg} onChange={(e) => {setYearBirth(e.target.value);setIsEdited(true)}} >
                          <option>السنة</option>
                          <option value="1940">1940</option>
                          <option value="1941">1941</option>
                          <option value="1942">1942</option>
                          <option value="1943">1943</option>
                          <option value="1944">1944</option>
                          <option value="1945">1945</option>
                          <option value="1946">1946</option>
                          <option value="1947">1947</option>
                          <option value="1948">1948</option>
                          <option value="1949">1949</option>
                          <option value="1950">1950</option>
                          <option value="1951">1951</option>
                          <option value="1952">1952</option>
                          <option value="1953">1953</option>
                          <option value="1954">1954</option>
                          <option value="1955">1955</option>
                          <option value="1956">1956</option>
                          <option value="1957">1957</option>
                          <option value="1958">1958</option>
                          <option value="1959">1959</option>
                          <option value="1960">1960</option>
                          <option value="1961">1961</option>
                          <option value="1962">1962</option>
                          <option value="1963">1963</option>
                          <option value="1964">1964</option>
                          <option value="1965">1965</option>
                          <option value="1966">1966</option>
                          <option value="1967">1967</option>
                          <option value="1968">1968</option>
                          <option value="1969">1969</option>
                          <option value="1970">1970</option>
                          <option value="1971">1971</option>
                          <option value="1972">1972</option>
                          <option value="1973">1973</option>
                          <option value="1974">1974</option>
                          <option value="1975">1975</option>
                          <option value="1976">1976</option>
                          <option value="1977">1977</option>
                          <option value="1978">1978</option>
                          <option value="1979">1979</option>
                          <option value="1980">1980</option>
                          <option value="1981">1981</option>
                          <option value="1982">1982</option>
                          <option value="1983">1983</option>
                          <option value="1984">1984</option>
                          <option value="1985">1985</option>
                          <option value="1986">1986</option>
                          <option value="1987">1987</option>
                          <option value="1988">1988</option>
                          <option value="1989">1989</option>
                          <option value="1990">1990</option>
                          <option value="1991">1991</option>
                          <option value="1992">1992</option>
                          <option value="1993">1993</option>
                          <option value="1994">1994</option>
                          <option value="1995">1995</option>
                          <option value="1996">1996</option>
                          <option value="1997">1997</option>
                          <option value="1998">1998</option>
                          <option value="1999">1999</option>
                          <option value="2000">2000</option>
                          <option value="2001">2001</option>
                          <option value="2002">2002</option>
                          <option value="2003">2003</option>
                          <option value="2004">2004</option>
                          <option value="2005">2005</option>
                          <option value="2006">2006</option>
                          <option value="2007">2007</option>
                          <option value="2008">2008</option>
                          <option value="2009">2009</option>
                          <option value="2010">2010</option>
                          <option value="2011">2011</option>
                          <option value="2012">2012</option>
                          <option value="2013">2013</option>
                          <option value="2014">2014</option>
                          <option value="2015">2015</option>
                          <option value="2016">2016</option>
                          <option value="2017">2017</option>
                          <option value="2018">2018</option>
                          <option value="2019">2019</option>
                          <option value="2020">2020</option>
                          <option value="2021">2021</option>
                          <option value="2022">2022</option>
                        </select>
                       
                        
                      </div>


                    </div>
                
                    <div className="cell medium-5">
                      <label>الجنس</label>
                      <div className="flex-container align-justify">
                        <div className="input-radio">
                          <label htmlFor="gender">
                            {gender == 'Female' ? (
                              <input type="radio" value="Female" checked  name="gender" onFocus={resetMsg} onChange={(e) => {setGender(e.target.value);setIsEdited(true)}} />
                            ) : (
                              <input type="radio" value="Female" name="gender" onFocus={resetMsg} onChange={(e) => {setGender(e.target.value);setIsEdited(true)}} />
                            )}


أنثى</label>
                        </div>
                        
                        <div className="input-radio">
                          <label htmlFor="gender">

                            {gender == 'Male' ? (
                              <input type="radio" value="Male" checked name="gender" onFocus={resetMsg} onChange={(e) => {setGender(e.target.value);setIsEdited(true)}} />
                            ) : (
                              <input type="radio" value="Male" name="gender" onFocus={resetMsg} onChange={(e) => {setGender(e.target.value);setIsEdited(true)}} />
                            )}


                            ذكر </label>
                        </div>
                      </div>
                    </div>


                    <div className="cell medium-5">
                      <label>العمل </label>
                      <div className="input-field">
                        <input className="no-ico" type="text" defaultValue={user.user.occupation!="null"?user.user.occupation:''} name="occupation" placeholder="اكتب مجال عملك هنا" onFocus={resetMsg} onChange={(e) => {setOccupation(e.target.value);setIsEdited(true)}} />
                      </div>
                    </div>
                     
                    

                  </div>
                  <div className="btns-area text-center">
                    <button onClick={login} className="button expanded" value="حفظ" disabled={!isEdited}>  حفظ </button>
                  </div>


                </div>

              </div>
            </div>
          </div>
        </div>
      </div>


    );
  }
}

export default EditProfile;
